export const URLS = {
  DREP_ERROR_CONDITIONS:
    "https://docs.gov.tools/cardano-govtool/using-govtool/dreps/drep-error-conditions",
};
